'use strict'
import {Modal} from './modal';

const home = {

	init(){
		if(document.querySelector('.page-template-tpl-page-home')){
			// window.addEventListener('DOMContentLoaded', ()=>{
			// 	setTimeout( ()=> {
			// 		this.checkURLToPopinDisplay();
			// 	}, 250)
			// })
		}
	},

	// SI VIENT DE LA PAGE DE FORMULAIRE ET QU'IL EST VALIDE
	checkURLToPopinDisplay(){
		const messageContact = document.querySelector('#message-form-contact').dataset.message;
		const messageCandidature = document.querySelector('#message-form-candidature').dataset.message;
		
		if(location.search === '?message-form-contact=ok'){
			new Modal({messageContact}, 'sucess');
			window.history.pushState("", "", "/");
		}
		if(location.search === '?message-form-candidature=ok'){
			new Modal({messageCandidature}, 'sucess');
			window.history.pushState("", "", "/");
		}
	}
} 

export default home;